// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rDNA-metricsSection .rDNA-iconContainer {
  display: flex;
  flex-direction: column;
}

.rDNA-metricsSection {
  display: flex;
  flex-direction: row;
}

.rDNA-metricsSection .rDNA-iconContainer {
  justify-content: center;
  align-items: center;
}

@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
.rDNA-metricsSection .rDNA-metricsCard, .rDNA-metricsSection .rDNA-metricGrid, .rDNA-metricsSection {
  height: 100%;
  width: 100%;
}

@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
.rDNA-metricsSection .light-blue {
  background: #3792BF;
}
.rDNA-metricsSection .navy {
  background: #1B3E78;
}
.rDNA-metricsSection .pink {
  background: #0CAD99;
}
.rDNA-metricsSection .rDNA-negative {
  color: #FF0000;
}
.rDNA-metricsSection .rDNA-positive {
  color: #00B300;
}
.rDNA-metricsSection .rDNA-iconContainer {
  border-radius: 50%;
  color: #fff;
}
.rDNA-metricsSection .rDNA-iconCardTitle {
  margin-top: 0px;
}
.rDNA-metricsSection .unavailable {
  color: #1B3E78;
  font-weight: bold;
  font-size: 120%;
  margin-top: 5px;
}

.rDNA-metricsCard {
  margin-top: 10px;
}

@media screen and (max-width: 767.7px) {
  .rDNA-metricsSection .rDNA-iconContainer {
    height: 45px;
    width: 45px;
  }
  .rDNA-metricsSection .rDNA-iconContainer {
    font-size: 16px;
    margin: 0 10px;
  }
}
@media screen and (max-width: 1023.7px) and (min-width: 768px) {
  .rDNA-metricsSection .rDNA-iconContainer {
    height: 35px;
    width: 35px;
  }
  .rDNA-metricsSection .rDNA-iconContainer {
    font-size: 16px;
    margin-right: 0;
  }
}
@media screen and (max-width: 1199.7px) and (min-width: 1024px) {
  .rDNA-metricsSection .rDNA-iconContainer {
    height: 45px;
    width: 45px;
  }
  .rDNA-metricsSection .rDNA-iconContainer {
    font-size: 20px;
    margin-right: 0;
  }
}
@media screen and (max-width: 2559.7px) and (min-width: 1199.7px) {
  .rDNA-metricsSection .rDNA-iconContainer {
    height: 55px;
    width: 55px;
  }
  .rDNA-metricsSection .rDNA-iconContainer {
    font-size: 26px;
    margin-right: 0;
  }
}
@media screen and (min-width: 2560px) {
  .rDNA-metricsSection .rDNA-iconContainer {
    height: 75px;
    width: 75px;
  }
  .rDNA-metricsSection .rDNA-iconContainer {
    font-size: 30px;
    margin-right: 30px;
  }
}
.edit-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}`, "",{"version":3,"sources":["webpack://./src/theme/placeholders/_flexboxes.scss","webpack://./src/app/profiles/dashboard/elements/company-metrics/company-metrics.component.scss","webpack://./src/theme/fonts.scss","webpack://./src/theme/variables.scss","webpack://./src/theme/placeholders/_quickStyles.scss"],"names":[],"mappings":"AACA;EAC0B,aAAA;EACA,sBAAA;ACA1B;;ADGA;EAC0B,aAAA;EACA,mBAAA;ACA1B;;ADGA;EAC0B,uBAAA;EACA,mBAAA;ACA1B;;ACbA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ADgBF;ACbA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;ADeF;ACZA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ADcF;ACXA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;ADaF;ACVA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ADYF;ACTA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;ADWF;ACRA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ADUF;ACPA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ADSF;ACNA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ADQF;ACLA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ADOF;ACJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;ADMF;ACHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ADKF;ACFA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;ADIF;ACDA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;ADGF;ACAA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ADEF;ACCA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ADCF;ACEA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;ADAF;ACGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ADDF;AEnHA;;;;;uBAAA;ACNA;EACE,YAAA;EACA,WAAA;AHiIF;;ACpIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ADuIF;ACpIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;ADsIF;ACnIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ADqIF;AClIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;ADoIF;ACjIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ADmIF;AChIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;ADkIF;AC/HA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ADiIF;AC9HA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ADgIF;AC7HA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;AD+HF;AC5HA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AD8HF;AC3HA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;AD6HF;AC1HA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AD4HF;ACzHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;AD2HF;ACxHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;AD0HF;ACvHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ADyHF;ACtHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ADwHF;ACrHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;ADuHF;ACpHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ADsHF;AE1OA;;;;;uBAAA;AFGE;EAAwC,mBEQ5B;AFwOd;AA/OE;EAAwC,mBEI9B;AF8OZ;AAjPE;EAAwC,mBEE7B;AFkPb;AAhPE;EAAwC,cEe7B;AFoOb;AAlPE;EAAwC,cEa3B;AFwOf;AAnPE;EACwC,kBAAA;EAGA,WEP7B;AF0Pb;AAjPE;EACwC,eAAA;AAmP1C;AAjPE;EACwC,cEd9B;EFe8B,iBAAA;EACE,eAAA;EAEF,eAAA;AAkP1C;;AA9OA;EACE,gBAAA;AAiPF;;AA9OA;EAEE;IAA+B,YADD;IACuB,WADvB;EAmP9B;EA/OE;IAE8B,eAAA;IACA,cAAA;EAgPhC;AACF;AA3OA;EAEE;IAA+B,YADD;IACuB,WADvB;EA+O9B;EA3OE;IAEE,eAAA;IACA,eAAA;EA4OJ;AACF;AAzOA;EAEE;IAA+B,YADD;IACuB,WADvB;EA6O9B;EAzOE;IAEE,eAAA;IACA,eAAA;EA0OJ;AACF;AAtOA;EAEE;IAAgC,YADF;IACwB,WADxB;EA0O9B;EAtOE;IAEE,eAAA;IACA,eAAA;EAuOJ;AACF;AAnOA;EAEE;IAAiC,YADH;IACyB,WADzB;EAuO9B;EAnOE;IAEE,eAAA;IACA,kBAAA;EAoOJ;AACF;AAhOA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AAiOF","sourcesContent":["\n%flex-column            {\n                          display: flex;\n                          flex-direction: column;\n                        }\n\n%flex-row               {\n                          display: flex;\n                          flex-direction: row;\n                        }\n\n%flex-jCenter-aCenter   {\n                          justify-content: center;\n                          align-items: center;\n                        }\n\n%flex-jCenter-aStart    {\n                          justify-content: center;\n                          align-items: flex-start;\n                        }\n\n%flex-jCenter-aEnd      {\n                          justify-content: center;\n                          align-items: flex-end;\n                        }\n\n%flex-jStart-aCenter    {\n                          justify-content: flex-start;\n                          align-items: center;\n                        }\n\n%flex-jStart-aStart     {\n                          justify-content: flex-start;\n                          align-items: flex-start;\n                        }\n\n%flex-jStart-aEnd       {\n                          justify-content: flex-start;\n                          align-items: flex-end;\n                        }\n\n%flex-jEnd-aCenter      {\n                          justify-content: flex-end;\n                          align-items: center;\n                        }\n\n%flex-jEnd-aStart       {\n                          justify-content: flex-end;\n                          align-items: flex-start;\n                        }\n\n%flex-jEnd-aEnd         {\n                          justify-content: flex-end;\n                          align-items: flex-end;\n                        }\n\n","@import 'placeholders/flexboxes';\n@import 'placeholders/fonts';\n@import \"placeholders/quickStyles\";\n@import \"variables/breakpoints\";\n@import 'variables';\n\n.rDNA-metricsSection                  {\n                                        @extend %max-HW-100;\n                                        @extend %flex-row;\n\n  .light-blue                           { background: $accent-blue; }\n  .navy                                 { background: $dark-text; }\n  .pink                                 { background: $accent-btn; }\n\n  .rDNA-metricGrid                      { @extend %max-HW-100; }\n  .rDNA-metricsCard                     { @extend %max-HW-100;}\n  .rDNA-negative                        { color: $rDNA-alert; }\n  .rDNA-positive                        { color: $rDNA-success; }\n\n  .rDNA-iconContainer                   {\n                                          border-radius: 50%;\n                                          @extend %flex-column;\n                                          @extend %flex-jCenter-aCenter;\n                                          color: $light-text;\n                                        }\n  .rDNA-iconCardTitle                   {\n                                          margin-top: 0px; // Added margin at the top\n                                        }\n  .unavailable                          {\n                                          color: $dark-text;  // You can adjust the color for the unavailable state\n                                          font-weight: bold;\n                                            font-size: 120%; \n                                          // text-transform: uppercase;\n                                          margin-top: 5px;\n                                        }\n}\n\n.rDNA-metricsCard{\n  margin-top: 10px;\n}\n\n@media screen and (max-width: $breakpoint-sm-max) {\n  $icon-height:                 45px;\n  %icon-dimension-sm           { height: $icon-height; width: $icon-height; }\n\n  .rDNA-metricsSection        {\n    .rDNA-iconContainer         {\n                                  @extend %icon-dimension-sm;\n                                  font-size: 16px;\n                                  margin: 0 10px;\n                                }\n  }\n}\n\n\n@media screen and ( max-width: $breakpoint-md-max) and (min-width: $breakpoint-md-min) {\n  $icon-height:                 35px;\n  %icon-dimension-md           { height: $icon-height; width: $icon-height; }\n\n  .rDNA-metricsSection        {\n    .rDNA-iconContainer         {\n      @extend %icon-dimension-md;\n      font-size: 16px;\n      margin-right: 0;\n    }\n  }\n}\n@media screen and ( max-width: $breakpoint-lg-max) and (min-width: $breakpoint-lg-min) {\n  $icon-height:                 45px;\n  %icon-dimension-lg           { height: $icon-height; width: $icon-height; }\n\n  .rDNA-metricsSection        {\n    .rDNA-iconContainer         {\n      @extend %icon-dimension-lg;\n      font-size: 20px;\n      margin-right: 0;\n    }\n  }\n}\n\n@media screen and ( max-width: $breakpoint-xxl-max) and (min-width: $breakpoint-lg-max) {\n  $icon-height:                 55px;\n  %icon-dimension-xxl           { height: $icon-height; width: $icon-height; }\n\n  .rDNA-metricsSection        {\n    .rDNA-iconContainer         {\n      @extend %icon-dimension-xxl;\n      font-size: 26px;\n      margin-right: 0;\n    }\n  }\n}\n\n@media screen and (min-width: $breakpoint-xxxl-min) {\n  $icon-height:                 75px;\n  %icon-dimension-xxxl           { height: $icon-height; width: $icon-height; }\n\n  .rDNA-metricsSection        {\n    .rDNA-iconContainer         {\n      @extend %icon-dimension-xxxl;\n      font-size: 30px;\n      margin-right: 30px;\n    }\n  }\n}\n\n.edit-overlay {\n  position: absolute; // Position the overlay absolutely\n  top: 0; // Cover the top\n  left: 0; // Cover the left\n  right: 0; // Cover the right\n  bottom: 0; // Cover the bottom\n\n  display: flex; // Center content if needed\n  justify-content: center; // Center horizontally\n  align-items: center; // Center vertically\n  z-index: 10; // Ensure it appears above other elements\n}\n","@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-Black.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-Bold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-Medium.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Regular.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-Light.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLight.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-Thin.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-BlackItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-BoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-MediumItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Italic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-LightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-ThinItalic.ttf');\n}\n\n","@import \"fonts\";\n\n// this file is more for variables that cannot be used in the theme\n// many of these should be migrated after the material theme has been configured.\n\n$font-family: \"Dm Sans\", sans-serif;\n\n/* Old palette\n$accent-btn: #DD7EB0;\n$dark-text: #303f71;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #84D9FD;*/\n\n$accent-btn: #0CAD99;\n$dark-text: #1B3E78;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #3792BF;\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$app-background: #F4F7FE;\n\n$rDNA-success: #00B300;\n$rDNA-alert: #FF0000;\n$rDNA-neutral: #FFBF00;\n","\n%max-HW-100 {\n  height: 100%;\n  width: 100%;\n}\n\n%full-screen-background-overlay {\n  display: flex;\n  flex-direction: column;\n  z-index: 98;\n  background-color: rgba(#e0e0e0, 0.5);\n  backdrop-filter: blur(4px);\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100dvw;\n  height: 100dvh;\n  align-items: center;\n  justify-content: center;\n}\n\n%white-background-raised-container {\n  height: fit-content;\n  max-height: 80dvh;\n  width: 70dvw;\n  border-radius: 50px;\n  background: white;\n  box-shadow: 20px 20px 20px #d9d9d9,\n  -20px -20px 20px #e0e0e0;\n  z-index: 99;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n// Base x-button style\n%x-button {\n  cursor: pointer;\n  z-index: 9999;\n\n  &:hover {\n    color: #333;\n  }\n}\n\n// Modifier: small\n%x-button--small {\n  position: absolute;\n  font-size: 0.75rem;\n  top: 0.5rem;\n  left: 14rem;\n  background: none;\n  color: grey;\n  border: none;\n}\n\n// Modifier: large\n%x-button--large {\n  position: absolute;\n  font-size: 1.25rem;\n  top: 0.2rem;\n  left: 0.2rem;\n  background: none;\n  color: grey;\n  border: none;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
